import { useNavigate } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionHead } from "../components/ui-bits";
import { PILLARS } from "../config/defaults";

export default function InvestorTeaser() {
  const navigate = useNavigate();
  return (
    <section id="investors" className="relative overflow-hidden py-20 lg:py-28" data-testid="investor-teaser-section">
      <div className="pointer-events-none absolute left-1/2 top-0 h-[400px] w-[700px] -translate-x-1/2 rounded-full" style={{ background: "radial-gradient(circle, rgba(124,77,255,0.16), transparent 70%)" }} />
      <div className="container-x relative">
        <div className="rounded-[2rem] border border-white/10 bg-graphite/60 p-8 backdrop-blur-sm sm:p-12" data-testid="investor-teaser-panel">
          <div className="flex flex-col gap-10 lg:flex-row lg:items-start lg:justify-between">
            <div className="max-w-xl">
              <SectionHead
                eyebrow="For Investors"
                title={<>Building the Operating Layer for Modern Car Care.</>}
                sub="CARZA is currently building its service network, technology layer and B2B relationships."
              />
              <Reveal delay={0.2} className="mt-8">
                <button onClick={() => navigate("/investors")} className="btn btn-primary px-7 py-3.5" data-testid="investor-teaser-cta">
                  Request Investor Deck <ArrowUpRight size={15} />
                </button>
              </Reveal>
            </div>
            <div className="grid flex-1 grid-cols-1 gap-3 sm:grid-cols-2 lg:max-w-xl">
              {PILLARS.map((p, i) => (
                <Reveal key={p.no} delay={0.1 + i * 0.06}>
                  <div className="h-full rounded-2xl border border-white/10 bg-white/[0.02] p-5 transition-colors hover:border-carza/30" data-testid={`pillar-${p.no}`}>
                    <span className="font-mono text-[11px] tracking-widest text-carza">{p.no}</span>
                    <h3 className="mt-2 text-[15px] font-semibold leading-snug text-paper">{p.title}</h3>
                    <p className="mt-1.5 text-xs leading-relaxed text-mist">{p.desc}</p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
